// Languette de la messagerie de l'app (decision de Louka du 04/10) : monte sous le fournisseur du
// panneau lateral de conversation, ce composant annonce a l'app (message « panneau ») la largeur du
// panneau ouvert, et 0 quand il se ferme ou que la conversation se demonte. Sans modele `coquille`
// (chat hors de l'app), il ne fait rien. Le panneau redimensionnable porte `data-panel-id` (react-
// resizable-panels) : sa largeur est suivie par un ResizeObserver, ce qui couvre aussi l'animation
// d'ouverture et le redimensionnement a la souris. Sur mobile, Dust rend le panneau en plein ecran sans
// panneau redimensionnable : on annonce alors la largeur de la fenetre, et l'app cache la languette.
import { useConversationSidePanelContext } from "@app/components/assistant/conversation/ConversationSidePanelContext";
import { largeurAnnoncee } from "@app/lib/compta/annonce_panneau";
import { envoyer, useNavigationDeLApp } from "@app/lib/compta/navigation_app";
import { useEffect } from "react";

export function AnnoncePanneauLateral() {
  const nav = useNavigationDeLApp();
  const coquille = nav?.coquille === true;
  const { currentPanel, panelRef } = useConversationSidePanelContext();
  const ouvert = currentPanel !== null && currentPanel !== undefined;

  useEffect(() => {
    if (!coquille) {
      return;
    }
    const id = panelRef.current?.getId();
    const element = id
      ? document.querySelector<HTMLElement>(`[data-panel-id="${id}"]`)
      : null;
    if (!element) {
      envoyer({
        type: "panneau",
        largeur: largeurAnnoncee(ouvert, window.innerWidth),
      });
      return () => envoyer({ type: "panneau", largeur: 0 });
    }
    const annoncer = () =>
      envoyer({
        type: "panneau",
        largeur: largeurAnnoncee(ouvert, element.getBoundingClientRect().width),
      });
    annoncer();
    const observateur = new ResizeObserver(annoncer);
    observateur.observe(element);
    return () => {
      observateur.disconnect();
      envoyer({ type: "panneau", largeur: 0 });
    };
  }, [coquille, ouvert, panelRef]);

  return null;
}
